import React from 'react';
import Autocomplete, { AutocompleteRenderInputParams } from '@material-ui/lab/Autocomplete';
import { Info } from '@material-ui/icons';
import { TextField, Grid, Tooltip, Box, Typography } from '@material-ui/core';
import { PersonModel } from '../../models/personModel';
import { CertificationModel } from '../../models/certificationModel';

interface RenderOptionProps {
  official: PersonModel;
}

interface TooltipProps {
  certifications?: CertificationModel[];
}

export function SelectOfficial(props: any) {
  const { width, value, variant, label } = props;

  function getInput(params: AutocompleteRenderInputParams) {
    //This is nasty hack as changing variant dynamically does not work with current materialUI.
    switch (variant) {
      case 'filled':
        return (
          <TextField
            {...params}
            style={{ width }}
            label={label}
            variant={'filled'}
            inputProps={{
              ...params.inputProps,
            }}
          />
        );
      case 'outlined':
        return (
          <TextField
            {...params}
            style={{ width }}
            label={label}
            variant={'outlined'}
            inputProps={{
              ...params.inputProps,
            }}
          />
        );
      case 'standard':
      default:
        return (
          <TextField
            {...params}
            style={{ width }}
            label={label}
            variant={'standard'}
            inputProps={{
              ...params.inputProps,
            }}
          />
        );
    }
  }

  return (
    <Autocomplete
      {...props}
      value={value}
      getOptionLabel={(opt: any) => `${opt.preferredGivenName} ${opt.preferredFamilyName}`}
      renderInput={params => getInput(params)}
      renderOption={(official: PersonModel) => <RenderOption official={official} />}
    />
  );
}

function RenderOption(props: RenderOptionProps) {
  const { official } = props;

  return (
    <Grid container direction='row'>
      <Grid item xs={11}>
        <Typography>{`${official.preferredGivenName} ${official.preferredFamilyName}`}</Typography>
      </Grid>
      <Grid item xs={1}>
        <Box
          textAlign='end'
          hidden={!official.certifications || official.certifications?.length === 0}
        >
          <Tooltip title={<CertificationsTooltip certifications={official.certifications} />}>
            <Info color='disabled' />
          </Tooltip>
        </Box>
      </Grid>
    </Grid>
  );
}

function CertificationsTooltip(props: TooltipProps) {
  const { certifications } = props;

  return (
    <Grid container direction='column'>
      {certifications?.map((cert, index) => {
        return (
          <Grid item key={index}>
            {cert.type}
          </Grid>
        );
      })}
    </Grid>
  );
}
